import styled from 'styled-components';
import colors from '../../../../assets/colors';

export const Content = styled.div`
  max-width: 460px;
  
  h2 {
    padding: 30px;
    color: ${colors.primary};
    font-size: 1.5rem;
  }

  @media screen and (max-width: 560px) {
    min-width: 0px;
  }
`;

export const ListItem = styled.div`
  padding: 20px 0;
  background-color: #E9E9E9;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  cursor: pointer;
  
  .item {
    display: flex;
    flex-direction: 'row';
    align-items: center;
    padding: 0 30px 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #DDDDDD;

    .avatar {
      min-width: 40px;
      height: 40px;
      margin-right: 15px;
      border-radius: 50px;
      border: 3px solid #222222;
    }

    h3 {
      font-size: 1.0rem;
      font-weight: 700;
      margin-bottom: 2px;
    }

    p {
      font-size: 0.9rem;
      line-height: 18px;
    }

    :last-child {
      padding-bottom: 0;
      margin-bottom: 0;
      border: none;
    }

    :hover { opacity: 0.8; }
  }
`;
